import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";

const Footer = () => {
    const footerLinks = {
        FurtherInfo: [
            { index: 0, LinkText: 'About Us', LinkUrl: '/who-we-are/about-eyantra' },
            { index: 1, LinkText: 'Contact Us', LinkUrl: '/contact-us' },
            // { index: 2, LinkText: 'Careers', LinkUrl: './Careers' },
            // { index: 3, LinkText: 'Privacy Policy', LinkUrl: './privacy-policy' },
        ],
        QuickLinks: [
            { index: 4, LinkText: 'Blogs', LinkUrl: '/blogs' },
            { index: 5, LinkText: '2024 Corporate Gifting Report', LinkUrl: '/gifting-report-2024' },
            
        ],
        CustomerService: [
            { index: 6, LinkText: 'Help & FAQs', LinkUrl: '/contact-us' },
            { index: 7, LinkText: 'Terms & Conditions', LinkUrl: '/terms-and-conditions' },
            { index: 8, LinkText: 'Privacy Policy', LinkUrl: '/privacy-policy' },
            { index: 9, LinkText: 'Shipping Policy', LinkUrl: '/shipping-policy' },
            
        ],
        ProductCatalogs: [
            { index: 10, LinkText: 'Diwali Catalog', LinkUrl: '/catalog/diwali' },
            { index: 10, LinkText: 'New Year Catalog', LinkUrl: '/catalog/new-year' },
            { index: 10, LinkText: 'New Year Catalog', LinkUrl: '/catalog/other-brand-catalog' },
            { index: 12, LinkText: 'Download Catalog', LinkUrl: 'https://catalog.eyantra.com' },
            
        ]
    };

    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
  
    const handleSubmit = async (e) => {
        e.preventDefault();
      
        if (!email) {
          setMessage('Please enter a valid email');
          return;
        }
      
        setLoading(true);
      
        try {
          const response = await fetch('https://api.brevo.com/v3/contacts', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'api-key': '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',  // Replace with your actual API key
            },
            body: JSON.stringify({
              email: email,  
              listIds: [118],
            }),
          });
      
          const data = await response.json();
      
          if (response.ok) {
            setMessage('Thank you for subscribing!');
            setEmail('')
          } else {
            if (data.code === 'duplicate_parameter' && data.message.includes('email')) {
              setMessage('You are already subscribed!');
            } else {
              console.error('Brevo API Error:', data);  
              setMessage(`Error: ${data.message || 'Something went wrong'}`);
            }
          }
        } catch (error) {
          console.error('Error:', error);  
          setMessage('Something went wrong. Please try again.');
        } finally {
          setLoading(false);
        }
      };
      
      

    return (
        <>
            <div className="container-fluid p-0 m-0 bg-darkGreen">
                <Container>
                    <Row className="pt-2 pb-5">
                        <h2 className="fs-24 text-white text-uppercase text-center pt-3">Subscribe to our Newsletter</h2>
                        {/* <Form className="text-center">
                            <input type="email" placeholder="Enter your email address" className="p-2 px-5 rounded border-0 mx-3" />
                            <Button className="p-2 px-5 border-0 fs-16" id="btnSecondary">Submit</Button>
                        </Form> */}
                    <div className="text-center">
                        <Form onSubmit={handleSubmit} className="row p-2  align-items-center justify-content-center">
                            <input
                            type="email"
                            placeholder="Enter your email address"
                            className="p-2 px-5 rounded border-0 mx-3 col-md-3 my-2"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            />
                            <Button className="p-2 px-5 border-0 fs-16 col-md-2" id="btnSecondary" type="submit" disabled={loading}>
                            {loading ? 'Submitting...' : 'Submit'}
                            </Button>
                        </Form>
                        {message && <p className="text-white pt-2 fs-18">{message}</p>}
                    </div>
                    </Row>
                    <Row className="pb-5">
                        <Col md={6} lg={3}>
                            <h3 className="text-white fs-20">Further Info</h3>
                            {footerLinks.FurtherInfo.map((item) => (
                                <p className="footerLink pb-0 mb-2" key={item.index}>
                                    <a href={item.LinkUrl} className="footerLink text-decoration-none">{item.LinkText}</a>
                                </p>
                            ))}
                        </Col>
                        
                        <Col md={6} lg={3}>
                            <h3 className="text-white fs-20">Quick Links</h3>
                            {footerLinks.QuickLinks.map((item) => (
                                <p className="footerLink pb-0 mb-2" key={item.index}>
                                    <a href={item.LinkUrl} className="footerLink text-decoration-none">{item.LinkText}</a>
                                </p>
                            ))}
                        </Col>

                        <Col md={6} lg={3}>
                            <h3 className="text-white fs-20">Customer Service</h3>
                            {footerLinks.CustomerService.map((item) => (
                                <p className="footerLink pb-0 mb-2" key={item.index}>
                                    <a href={item.LinkUrl} className="footerLink text-decoration-none">{item.LinkText}</a>
                                </p>
                            ))}
                        </Col>

                        <Col md={6} lg={3}>
                            <h3 className="text-white fs-20">Product Catalog</h3>
                            {footerLinks.ProductCatalogs.map((item) => (
                                <p className="footerLink pb-0 mb-2" key={item.index}>
                                    <a href={item.LinkUrl} className="footerLink text-decoration-none">{item.LinkText}</a>
                                </p>
                            ))}
                        </Col>
                        <Col md={6} lg={3} className="mt-3">
                            <h3 className="text-white fs-20">Address</h3>
                            
                                <p className=" pb-0 mb-2 footerLink text-decoration-none">
                                    eYantra, 301, 3rd Floor, CSR Estate, Plot No.8, Sector-1, HUDA Techno Enclave, Madhapur Main Road, Hyderabad <br></br> 500 081, Telangana, India.
                                </p>
                            
                        </Col>
                        <Col md={6} lg={3} className="mt-3">
                            <h3 className="text-white fs-20"><Icon icon="mdi:email" width="24px" height="24px" className="me-2 p-0"/>Email</h3>
                            
                                <p className=" pb-0 mb-2 footerLink text-decoration-none">
                                    <a href="mailto:info@eyantra.com" className="footerLink text-decoration-none">info@eyantra.com</a>
                                </p>
                        </Col>
                        <Col md={6} lg={3} className="mt-3">
                            <h3 className="text-white fs-20"><Icon icon="mdi:phone" width="24px" height="24px" className="me-2 p-0"/>Call us at</h3>
                            
                                <p className=" pb-0 mb-2 footerLink text-decoration-none">
                                    <a href="tel:8977921314" className="footerLink text-decoration-none">Hyderabad: +91-8977921314</a>
                                </p>
                        </Col>

                        <Col md={6} lg={3} className="mt-3">
                            <h3 className="text-white fs-20">Follow us on</h3>
                            <Row className="logos">
                                <Col md={2}>
                                    <a href="https://www.facebook.com/eyantraindustries"  target="_blank">
                                        <Icon icon="mdi:facebook" width="24" height="24" className="footerLink" />
                                    </a>
                                </Col>
                                <Col md={2}>
                                    <a href="https://www.instagram.com/eyantra_/"  target="_blank">
                                        <Icon icon="mdi:instagram" width="24" height="24" className="footerLink" />
                                    </a>
                                </Col>
                                <Col md={2}>
                                    <a href="https://in.linkedin.com/company/eyantramerchandise"  target="blank">
                                        <Icon icon="mdi:linkedin" width="24" height="24" className="footerLink" />
                                    </a>
                                </Col>
                                <Col md={2}>
                                    <a href="https://x.com/eYantra_"  target="_blank">
                                    <Icon icon="line-md:twitter-x" width="24" height="24" className="footerLink" />
                                    </a>
                                </Col>
                                <Col md={2}>
                                    <a href="https://www.youtube.com/@eYantraIndustries" target="_blank">
                                    <Icon icon="line-md:youtube" width="24" height="24" className="footerLink" />
                                    </a>
                                </Col>

                            </Row>
                        
                        </Col>
                    </Row>
                </Container>
                {/* <div className="container ">
                <a href="" target="_blank">
                    <Icon icon="logos:whatsapp-icon" width="50" height="50" className="position-fixed bottom-0 end-0 m-4 bg-light p-2 rounded-circle" />
                </a>
                </div> */}
            </div>
        </>
    );
};

export default Footer;
